import React, {PureComponent} from "react"
import {Row, Col, Grid} from "react-bootstrap"
import styled from "styled-components"

import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"
import {H2} from "@irati/ui/src//Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"
import authentication from "@irati/auth"

import {BannerCard} from "../Wallet"

interface StyledProps {
  isMobile: boolean
}

const StyledDiv = styled<StyledProps, "div">("div")`
  margin: 40px 0;
  text-align: ${({isMobile}) => (isMobile ? "center" : "inherit")};
`

class RewardBanner extends PureComponent<StyledProps> {
  render() {
    const {isMobile} = this.props
    const showRewardWallet = authentication.apps("wallet.rewardWallet")

    return (
      <Grid>
        <StyledDiv isMobile={isMobile}>
          <Grid>
            <Row>
              <Col xs={12} sm={4} lg={4}>
                <H2 small><FormattedMessage id="reward.banner.header" /></H2>
                <Row>
                  <Col xsHidden sm={12}>
                    <Para large center={isMobile}><FormattedMessage id="reward.banner.para" /></Para>
                  </Col>
                </Row>
              </Col>
              {showRewardWallet &&
                <Col xs={12} smOffset={1} sm={6}>
                  <BannerCard />
                </Col>
              }
            </Row>
          </Grid>
        </StyledDiv>
      </Grid>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isMobile: mq.lessThan.md
})

export default connect(mapStateToProps)(RewardBanner)
